/**
 * Creates a deterministic cache key for API requests.
 *
 * @param methodName - The API method name
 * @param payload - The request payload
 * @returns A cache key array containing [methodName, serializedPayload]
 */
export function createCacheKey<TPayload>(
  methodName: string,
  payload: TPayload,
): string[] {
  const method = String(methodName);

  const sortedPayload =
    payload && typeof payload === 'object' && !Array.isArray(payload)
      ? Object.keys(payload)
          .sort()
          .reduce<Record<string, unknown>>((sorted, key) => {
            sorted[key] = (payload as Record<string, unknown>)[key];
            return sorted;
          }, {})
      : payload;

  const payloadString = JSON.stringify(sortedPayload);
  return [method, payloadString];
}
